import { render, staticRenderFns } from "./EditMinSpendPolicyLimit.vue?vue&type=template&id=274ec594&"
import script from "./EditMinSpendPolicyLimit.vue?vue&type=script&lang=js&"
export * from "./EditMinSpendPolicyLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports